const LoginBox = ({ children }) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row", // ✅ always row
        maxWidth: "900px",
        width: "100%",
        height: "100%",
      }}
    >
      {children}
    </div>
  );
};

export default LoginBox;
